<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-10-08 10:53:38
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-21 13:15:16
 * @FilePath: /streamline_detail/src/views/home/components/newProductBaseInfo/quality-level.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div
      v-if="qualityLevel"
      v-zpm="{ sortid: 1, sortname: '等级弹窗' }"
      :class="{ 'quality-level__active': !qualityLevel.ms1 }"
      class="quality-level"
      @click="toggleConditionPopup"
    >
      <span
        v-if="qualityLevel.ms1"
        class="number"
        :class="{
          super: superColor,
          'super-number': qualityLevel.ms1 && !qualityLevel.ms2,
          'all-new-number': qualityLevel.ms1 == '全新'
        }"
        >{{ qualityLevel.ms1 }}</span
      >
      <span
        v-if="qualityLevel.ms2"
        class="font"
        :class="{
          super: superColor,
          big: isBiglong && qualityLevel.ms2.length > 3,
          'super-new-number': qualityLevel.ms1 == '全新'
        }"
        >{{ qualityLevel.ms2 }}</span
      >
    </div>
    <!-- 等级说明弹框 -->
    <RankDescription
      v-if="isNewRankPopup"
      ref="rankDescription"
      brandUpgrade
      :infoId="infoId"
      :cateId="cateId"
      :channelId="1"
      :qualityRatingModule="qualityRatingModule"
      :showFeedback="true"
      :feedbackData="feedbackData"
    ></RankDescription>
    <rank-pop v-else ref="rank" :report="report"></rank-pop>
  </div>
</template>
<script>
import { defineComponent, computed, ref } from '@vue/composition-api'
import { formatVal, getQueryString } from '@utils/index'
import { state } from '@/store'
export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    superColor: {
      type: Boolean,
      default: false
    },
    feedbackData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    RankPop: () => import(/* webpackChunkName: "rank-pop" */ '@/components/rank-pop.vue'),
    RankDescription: async () => {
      require('@zz-yp/b2c-ui/lib/rank-description/style.css')
      return await import(
        /* webpackChunkName: "RankDescription" */ '@zz-yp/b2c-ui/src/rank-description/index'
      )
    }
  },
  setup(props) {
    const infoId = getQueryString('infoId') || state.infoId
    const rankDescription = ref(null)
    const rank = ref(null)
    const cateId = state.cateId || ''
    const infoLv = computed(() => {
      return props.dataInfo?.infoLv || {}
    })

    const qualityLevel = computed(() => {
      if (infoLv.value.level) {
        return formatVal(infoLv.value.level)
      }
      return ''
    })

    const report = computed(() => {
      return props.dataInfo?.report || {}
    })

    // 兼容即有发售价又有新品价  或者 既有券前价又有新品价， 然后成色为全新仅拆封的情况 ， 样式会错乱， 所以fontsize 设置小点
    const isBiglong = computed(() => {
      const {
        debutPrice = '',
        priceCent = '',
        newPriceCent = ''
      } = props.dataInfo?.handPriceVo || {}
      if (debutPrice && newPriceCent) return true
      if (priceCent && newPriceCent) return true
      return false
    })

    const qualityRatingModule = computed(() => {
      return report.value?.conditionIntro || {}
    })

    const isNewRankPopup = computed(() => {
      const { finenessLevelValueId, finenessDialogContents } = qualityRatingModule.value
      return !!(finenessDialogContents || []).find(
        ({ valueId }) => valueId === finenessLevelValueId
      )
    })

    function toggleConditionPopup() {
      if (isNewRankPopup.value) {
        rankDescription.value.togglePopup()
      } else {
        rank.value.togglePopup()
      }
    }

    return {
      infoId,
      cateId,
      rankDescription,
      rank,
      infoLv,
      qualityLevel,
      isNewRankPopup,
      report,
      qualityRatingModule,
      toggleConditionPopup,
      state,
      isBiglong
    }
  }
})
</script>
<style scoped lang="scss">
// /deep/ .b2c-rank-new-item {
//   &.container {
//     .header {
//       height: 1.8rem;
//       span {
//         margin-top: 60px !important;
//       }
//     }
//   }
// }
/deep/ .content-box {
  .z-swipe {
    border-radius: 16px !important;
  }
  .custom-indicator {
    border-radius: 0 0 16px 16px !important;
  }
}
.container.b2c-rank-desc {
  width: 0;
}
.quality-level {
  display: flex;
  align-items: center;
  .number {
    color: #111111;

    font-size: 48px;
    font-family: Akrobat-ExtraBold, Akrobat;
    line-height: 40px;
    &.super-number {
      font-size: 40px;
    }
    &.all-new-number {
      color: #111111;
      font-weight: 500;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      line-height: 32px;
    }
  }
  .font {
    position: relative;
    top: -8px;
    margin-left: 3px;
    color: #111111;
    font-weight: 500;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    &.super-new-number {
      top: -5px;
      left: 2px;
    }
  }
  .super {
    color: #fff;
  }
  .big {
    font-size: 24px !important;
  }

  img {
    position: relative;
    top: -2px;
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }
  &__active {
    .font {
      position: static;
      font-weight: 400;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 42px;
    }
    img {
      position: relative;
      top: -5px;
    }
  }
}
</style>
